<template>
  
  <div v-if="items.length > 0" class="text-left mt-4  rounded-lg  border-gray-200 border-b border-t border-r border-l mb-3">
    <Table 
    :headers="headers" 
    :data="items" 
    :row-key="[
      'id',
      'order_number',
      'final_amount',
      'order_status',
      'paymentgateway_id',
      'is_renewal',
      'client_id',
      'is_active',
      'created']" 
      :current-page="currentPage" 
      :isLoading="isLoading" 
      :per-page="15"
      >
      <template #id="{row}">
        <router-link :to="{ path: '/order/detail?orderid=' + row.id }"
              class="text-gray-500 no-underline hover:no-underline hover:bg-transparent">
              {{ row.id }}
            </router-link>
      </template>
        <!-- <template #header-order-id="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}   
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template> -->
      <template #header-create="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
      <template #actions="{ row }">
          <svg @click="openModal(row)" class="w-6 h-6 text-gray-500 dark:text-white" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-width="2"
                d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z" />
              <path stroke="currentColor" stroke-width="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            </svg>
        </template>
        <template #final_amount="{ row }">
          {{ formatPrice(row.final_amount, row.currency_code) }}
        </template>
        <template #order_status="{ row }">
          <paymentview :payment="row.order_status" />
        </template>
        <template #paymentgateway_id="{ row }">
          <gatewayview :gateway="row.paymentgateway_id" />
        </template>
        
        <template #is_renewal="{ value }">
          <span v-if="value">
              Renewal
            </span>
            <span v-else>
              Non-Renewal
            </span>
        </template>
        <template #client_id="{ row }">
          <Client :client="row.client_id" />
        </template>
        <template #is_active ={value}>
          <span v-if="value">
    Production
  </span>
  <span v-else>
    Testing
  </span>
  </template>
        <template #created="{ value }">
          <span class="text-sm">{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
      </Table>
    
    <t-modal-file ref="OpenModal">
      <div class="text-sm flex-col text-center relative">
        <span @click="closeX()" class="absolute -right-5 -top-6 bg-white rounded-full h-5 w-5 items-center cursor-pointer">
          x
        </span>
        <div class="relative overflow-x-auto">
          <div class="text-sm flex-col text-center">
            <table class="table-auto w-full text-sm text-left text-gray-500 dark:text-white">
              <thead class="text-xs uppercase bg-gray-200 dark:bg-gray-800 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-2 py-3">Orderline key</th>
                  <th scope="col" class="px-2 py-3">Name</th>
                  <th scope="col" class="px-2 py-3">Quantity</th>
                  <th scope="col" class="px-2 py-3">Price</th>
                  <th scope="col" class="px-2 py-3">Discounted Price</th>
                </tr>
              </thead>
              <tbody>

                <tr v-for="orderline in modalData?.orderlines" :key="orderline.id"
                  class="bg-white border-b dark:bg-gray-900 dark:border-gray-700">
                  <td class="px-2 py-4 font-medium text-gray-900 dark:text-white">
                    {{ orderline.id }}
                  </td>
                  <td class="px-2 py-4">
                    {{ orderline.name }}
                  </td>
                  <td class="px-2 py-4">
                    {{ orderline.quantity }}
                  </td>
                  <td class="px-2 py-4">
                    {{ formatPrice(orderline.price, modalData?.currency_code) }}
                  </td>
                  <td class="px-2 py-4">
                    {{
                      getDiscountPrice(
                        orderline.price,
                        orderline.final_price,
                        modalData?.currency_code,
                        orderline.currency_code,
                        orderline.quantity
                                    )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
      <div class="flex justify-center">
      </div>
    </t-modal-file>

  </div>
  <div v-else>
     <div v-if="!isLoading" class="relative mt-4 overflow-x-auto my-2 mb-4 rounded-lg  border-gray-200 border-b border-t border-r border-l">
  <table class="min-w-full h-64 text-sm rounded-lg text-left">
        <thead class="bg-gray-50 text-gray-700">
          <tr class="text-center uppercase">
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">No</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Order Id</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Order Number</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Amount</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Status</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">payment gateway</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">renewal type</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Client</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">ENVIRONMENT</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">transaction Date</th>
          
          </tr>
        </thead>
        <tbody class="bg-white w-full">
          <tr>
            <td colspan="10" class="text-center py-8 text-gray-500">
            <div class="flex-col items-center justify-center flex-nowrap flex" style="height: 574px;">
            <svg class="w-14 h-14 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
            </svg>
            <h4 class="text-base text-gray-600 mb-0">No Data</h4>
            <p class="text-sm text-gray-500">There are no data to display</p>
          </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Table from '@/components/form/table.vue'
import paymentview from '../../components/payments/payment.vue';
import gatewayview from '../../components/payments/gateway.vue';
import Client from '../../components/client/client.vue';
import constant from '../../store/constant';
import moment from 'moment';
const clientGramedia = constant.CLIENT_ID.GRAMEDIA;
export default {
  name: 'TableOrders',

  components: {
    paymentview,
    gatewayview,
    Client,
    Table
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  
  data() {
    return {
      clientGramedia,
      btnUpdateOfs: false,
      sorts: [],
      sortString:[],
      sortOrder: 'desc',
      endpoint: "https://gd-cms-be.gramedia.com/", 
      sortDesc: true,
      modalData: [],
      transProps: {
        enterActiveClass: 'animated fadeIn',
        leaveActiveClass: 'animated fadeOut',
        name: 'flip-list',
      },
      headers: [
        { label: 'no', key: 'no' },
        { label: 'order id', key: 'id' },
        { label: 'order number', key: 'order_number' },
        { label: 'amount', key: 'final_amount'},
        { label: 'status', key: 'order_status'},
        { label: 'payment gateway', key: 'paymentgateway_id', },
        { label: 'renewal type', key: 'is_renewal', },
        { label: 'Client', key: 'client_id', },
        { label: 'ENVIRONMENT', key: 'is_active', },
        { label: 'transaction Date', key: 'created', slotHeader: 'header-create' },
        
      ],
      fields: [
        { key: 'No', label: 'No' },
        { key: 'id', label: 'Order Key', sortable: true },
        {
          key: 'email',
          label: 'Email',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'order_number',
          label: 'Order Number',
        },
        {
          key: 'final_amount',
          label: 'Amount',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'status',
          label: 'Status',
          thClass: 'text-center',
        },
        {
          key: 'payment',
          label: 'Payment',
          thClass: 'pl-3',
        },
        {
          key: 'isrenewal',
          label: 'Renewal',
          thClass: 'pl-3',
        },
        {
          key: 'Client',
          label: 'Client',
          thClass: 'text-center',
        },
        {
          key: 'remote_order_number',
          label: 'Remote Order Number',
          variant: 'info',
        },
        {
          key: 'is_active',
          label: 'Environment',
          thClass: 'text-center',
        },
        { key: 'createdAt', label: 'Transaction Time' },
        {
          key: 'show_details',
          label: 'Show Details',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    };
  },
  methods: {
    ...mapActions('orders', ['updateOfs','fetchOrdersByEmail']),    
    formatPrice(value, currency) {
      if (value) {
        let formatter = null;
        if (currency == 'USD') {
          formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
          });
        } else {
          formatter = new Intl.NumberFormat('en-ID', {
            style: 'currency',
            currency: currency,
          });
        }

        return formatter.format(value);
      }

      return '0';
    },
    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      return '0';
    },
      formatDate(tgl) {
  return {
    date: moment(tgl).format('DD MMM YY'),
    time: moment(tgl).format('HH:mm:ss'),
  };
},
    openModal(data) {
      this.$refs.OpenModal.show();
      this.modalData = data;
    },
    closeX() {
      this.$refs.OpenModal.hide();
    },
    getDiscountPrice(totalAmount, finalAmount, currency, currencyOrder, qty) {
      if (!isNaN(totalAmount) && !isNaN(finalAmount)) {
        const discount =
          parseFloat(totalAmount) * parseInt(qty) - parseFloat(finalAmount);
        return this.formatPrice(
          parseFloat(discount),
          currency ? currency : currencyOrder,
        );
      }
      return '-';
    },
    sortBy(column) {
        let existingIndex = this.sorts.findIndex(s => s.column === column);

      if (existingIndex >= 0) {
        this.sorts[existingIndex].order =
          this.sorts[existingIndex].order === "asc" ? "desc" : "asc";

        const [item] = this.sorts.splice(existingIndex, 1);
        this.sorts.unshift(item);
      } else {
        this.sorts.unshift({ column, order: "asc" });
      }

    this.sortString = this.sorts
    .map(s => `${s.column}_${s.order}`)
    .join(",");
     this.$emit("sort-data", this.sortString);
        let payload = {
            page: this.currentPage,
            limit: this.perPage,
            email: this.$route.params.id,
            sort: this.sortString
          };
          this.fetchOrdersByEmail(payload);
        },
    actionUpdateOfs(offerID) {
      this.btnUpdateOfs = true;
      try {
        this.updateOfs({ offerID })
          .then(() => {
            this.alertMsg(
              'Item has been sent, may take a few minutes to be displayed',
              'success',
            );
            this.btnUpdateOfs = false;
          })
          .catch((err) => {
            if (err.response.status == 422) {
              err.response.data.errors.map((e) =>
                this.alertMsg(e.msg, 'error'),
              );
            } else {
              this.alertMsg(err.response.data.data.message, 'error');
            }
            this.btnUpdateOfs = false;
          });
      } catch (error) {
        console.log(error);
        this.alertMsg('Ops. Something Went Wrong !');
        this.btnUpdateOfs = false;
      }
    },

    alertMsg(msg, type) {
      this.$swal({
        icon: type,
        toast: true,
        position: 'top-end',
        title: msg,
        timer: 10000,
        text: this.message,
      });
    },
  }, 
};
</script>